@let showImageError = selectedLanguageIsStarted() && idControl.hasError('required');
<pct-feature-file-upload-material-component
  hideCardShadow="true"
  i18nScope="FILE_UPLOAD_MATERIAL"
  nameAttribute="is-cover-image-unitform"
  [config]="coverImageConfig"
  [formControl]="idControl"
  [hasErrorFromOutside]="showImageError"
  [service]="fileUploadService()"
  (change)="markAsTouched()"
/>

<mat-form-field class="w-full">
  <mat-label>{{
    `COVER_IMAGE_SUBTITLE_${selectedLanguage()}` | i18nPrefixConcat: i18nPrefix() | transloco
  }}</mat-label>
  <input matInput name="name" type="text" [formControl]="subtitleControl" />
  <mat-error [control]="subtitleControl" />
</mat-form-field>
